import { getImageUrl } from "@/utils/dedaloUtils";
import Layout from "@/components/Layout/Layout";
import ResourcesLayout from "./ResourcesLayout";

export default function Documents({ section, data, close, documents, white}) {

    return (
        <Layout section={section}>
            <ResourcesLayout data={data} close={close} white={white}>
                <ul className="area-card--documents link-dn">
                    {documents.map((doc) => (
                        <li className="is-flex gap is-align-items-flex-start">
                            <img src={getImageUrl(doc.identify_image)} alt="" width="78" height="110" loading="lazy" />
                            <div>
                                <a href={getImageUrl(doc.identify_image)} target="_blank"><p>{doc.identify_image_caption}</p></a>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M12 15V3M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/></g></svg>
                            </div>
                        </li>
                    ))}
                </ul>
            </ResourcesLayout>
        </Layout>
    )
}